export default {
    loadPersistedData: function(payload) {
        return {type: 'FORM_LOAD_PERSISTED_DATA', payload};
    },
    loadFormMetadata: function(formId, metadata) {
        return {type: 'FORM_LOAD_METADATA', formId, metadata};
    },
    createResponse: function(eventId, formId, answerUID) {
        return {type: 'FORM_CREATE_RESPONSE', formId, eventId, answerUID};
    },
    deleteResponse: function(answerUID) {
        return {type: 'FORM_DELETE_ANSWER_INSTANCE', answerUID};
    },
    sendResponse: function (answerUID) {
        return {type: 'FORM_SEND_ANSWER', answerUID};
    },
    uploadSuccess: function (answerUID) {
        return {type: 'FORM_UPLOAD_SUCCESS',    answerUID};
    },
    // --
    setValue: function(answerUID, questionId, value) {
        return {type: 'FORM_SET_ANSWER_VALUE', answerUID, questionId, value};
    },
};
